import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Row, Col, Input, message, Popconfirm, Badge } from 'antd';
import { 
  SettingOutlined, 
  DeleteOutlined, 
  SearchOutlined,
  DesktopOutlined,
  GlobalOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons';
import axios from 'axios';

const MobileBoxManagement = () => {
  const [boxes, setBoxes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  const BOX_API_URL = '/api/box/list/';

  const fetchBoxes = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BOX_API_URL);
      // Filtriramo testni box 294 kao i na ostalim stranama
      setBoxes(response.data.filter(b => b.id !== 294));
    } catch (error) {
      message.error('Greška pri učitavanju boxova');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBoxes();
  }, []);

  const handleDelete = async (id) => {
    try {
      // Koristimo DELETE metodu na API putanju
      await axios.delete(`${BOX_API_URL}${id}/`); 
      message.success('Box uspešno uklonjen iz sistema');
      fetchBoxes();
    } catch (error) {
      message.error('Brisanje nije uspelo. Proveri dozvole.');
    }
  };

  const filteredBoxes = boxes.filter(box => {
    const search = searchText.toLowerCase();
    return (
      (box.box_name || '').toLowerCase().includes(search) ||
      (box.box_id || '').toString().toLowerCase().includes(search) ||
      (box.location || '').toLowerCase().includes(search)
    );
  });

  const columns = [
    {
      title: 'Box Management',
      key: 'manage_card',
      render: (record) => (
        <div className="m-mini-card">
          {/* 1. INFO: Ime i ID */}
          <div className="m-card-col main-info">
            <div className="m-box-top">
              <Badge dot status={record.status === 'online' ? 'success' : 'error'}>
                <DesktopOutlined style={{ color: 'white', fontSize: '16px' }} />
              </Badge>
              <span className="box-name-text">{record.box_name || 'No Name'}</span>
            </div>
            <div className="box-sub-info">
              BOX ID: <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{record.box_id}</span>
            </div>
          </div>

          {/* 2. LOKACIJA */}
          <div className="m-card-col loc-info">
            <div className="tiny-label">LOCATION</div>
            <div className="loc-text-val">
              <GlobalOutlined style={{ fontSize: '10px', marginRight: '4px', color: '#64748b' }} />
              {record.location || 'N/A'}
            </div>
          </div>

          {/* 3. AKCIJA: Delete */}
          <div className="m-card-col action-btn">
            <Popconfirm 
              title="Obriši box?" 
              description="Ovo će trajno ukloniti box iz baze."
              onConfirm={() => handleDelete(record.id)}
              okText="Obriši"
              cancelText="Odustani"
              okButtonProps={{ danger: true }}
              icon={<ExclamationCircleOutlined style={{ color: '#ef4444' }} />}
            >
              <Button 
                type="text" 
                danger
                icon={<DeleteOutlined style={{ fontSize: '20px' }} />} 
                className="m-del-btn"
              />
            </Popconfirm>
          </div>
        </div>
      ),
    }
  ];

  return (
    <div className="mobile-dashboard-wrapper">
      {/* HEADER KARTICA */}
      <Row gutter={[8, 8]} style={{ marginBottom: '15px' }}>
        <Col span={24}>
          <div className="st-box" style={{ borderBottomColor: '#ef4444', height: '45px' }}>
            <Space>
              <SettingOutlined style={{ color: '#ef4444', fontSize: '20px' }} />
              <span style={{ color: 'white', fontWeight: 'bold', fontSize: '14px' }}>BOX MANAGEMENT ({boxes.length})</span>
            </Space>
          </div>
        </Col>
      </Row>

      {/* SEARCH POLJE */}
      <div style={{ marginBottom: '15px' }}>
        <Input
          placeholder="Pretraži (Ime, ID, Lokacija)..."
          prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
          onChange={e => setSearchText(e.target.value)}
          className="m-search-input"
          allowClear
        />
      </div>

      {/* TABELA / LISTA */}
      <Table 
        dataSource={filteredBoxes} 
        columns={columns} 
        rowKey="id" 
        loading={loading} 
        pagination={false} 
      />

      <style>{`
        .mobile-dashboard-wrapper { padding-bottom: 20px; }
        
        .st-box { 
          background: #1e293b; 
          border-radius: 8px; 
          border: 1px solid #334155; 
          border-bottom: 4px solid; 
          display: flex; 
          justify-content: center; 
          align-items: center; 
        }
        
        .m-search-input {
          background: #1e293b !important;
          border: 1px solid #334155 !important;
          color: white !important;
          border-radius: 8px !important;
          height: 45px !important;
        }
        .m-search-input input { background: transparent !important; color: white !important; }

        .ant-table { background: transparent !important; }
        .ant-table-thead { display: none !important; }
        .ant-table-tbody > tr > td { border: none !important; padding: 0 0 10px 0 !important; background: transparent !important; }

        .m-mini-card { 
          background: #1e293b; 
          border: 1px solid #475569; 
          border-radius: 10px; 
          padding: 12px; 
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .m-card-col { display: flex; flex-direction: column; min-width: 0; }
        .main-info { flex: 1.5; }
        .loc-info { flex: 1; border-left: 1px solid #334155; padding-left: 10px; }
        .action-btn { flex: 0 0 auto; }

        .m-box-top { display: flex; align-items: center; gap: 10px; margin-bottom: 4px; }
        .box-name-text { color: white !important; font-weight: 700; font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .box-sub-info { color: #64748b; font-size: 11px; margin-left: 26px; }

        .tiny-label { color: #94a3b8; font-size: 9px; font-weight: 900; margin-bottom: 2px; text-transform: uppercase; }
        .loc-text-val { color: #ffffff; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

        .m-del-btn {
            background: rgba(239, 68, 68, 0.1) !important;
            border-radius: 6px !important;
            width: 40px !important;
            height: 40px !important;
            display: flex !important;
            align-items: center;
            justify-content: center;
        }

        .ant-spin-dot-item { background-color: #3b82f6 !important; }
      `}</style>
    </div>
  );
};

export default MobileBoxManagement;